/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { CloseIcon, RightArrowFilledIcon, SendButton } from "../../assets/Icons";
import Button from "../../components/ui/Button";
import { sendRecipients, validateRecipient } from "../../services/recipientDetails";
import { countryOfResidence, receivingCountryData } from "../../utils";
import { Modals } from "./Modals";
import { StepFour } from "./StepFour";
import { StepOne } from "./StepOne";
import { StepThree } from "./StepThree";
import { StepTwo } from "./StepTwo";
import { Mixpanel } from "../../constants/mixpanel";
import RemitterIconNew from "../../assets/Icons/RemitterIconNew";

export const RecipientDetails = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState<number>(0);
  const [name, setName] = useState<string>("");
  const [isModalOpen, setIsModalOpen] = useState<string>("");
  const [relationship, setRelationship] = useState<string>("");
  const [category, setCategory] = useState<string>("");
  const [residenceCountry, setResidenceCountry] = useState<string>("");
  const [city, setCity] = useState<string>("");
  const [pin, setPin] = useState<string>("");
  const [address1, setAddress1] = useState<string>("");
  const [address2, setAddress2] = useState<string>("");
  const [bankCountry, setBankCountry] = useState<string>("");
  const [acNumber, setAcNumber] = useState<string>("");
  const [confirmAcNumber, setConfirmAcNumber] = useState<string>("");
  const [swiftCode, setSwiftCode] = useState<string>("");
  const [iban, setIban] = useState<string>("");
  const [unitNumber, setUnitNumber] = useState<string>("");
  const [bankName, setBankName] = useState<string>("");
  const [routingNumber, setRoutingNumber] = useState<string>("");
  const [transitCode, setTransitCode] = useState<string>("");
  const [bspCode, setBspCode] = useState<string>("");
  const [sortCode, setSortCode] = useState<string>("");
  const [refrence, setRefrence] = useState<string>("");
  const [bankAddress, setBankAddress] = useState("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isCorrespondingAccount, setIsCorrespondingAccount] = useState(false);
  const [bankAccountNameCorresponding, setBankAccountNameCorresponding] = useState("");
  const [bankAccountNumberCorresponding, setBankAccountNumberCorresponding] = useState("");
  const [confirmAccNumber, setConfirmAccNumber] = React.useState("");
  const [refrenceCorresponding, setRefrenceCorresponding] = useState("");
  const [isVerified, setIsVerified] = React.useState(false);
  const [validationError, setValidationError] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const disabled = "px-20 ml-36 py-4 font-bold bg-gray-300 rounded-md text-white text-[18px] opacity-50 cursor-not-allowed";
  const enabled = "px-20 ml-36 py-4 font-bold rounded-md text-white text-[18px]";
  const selectedStep = "flex flex-col items-center px-6 py-2 rounded bg-cyan-200";
  const nonSelectedStep = "flex flex-col items-center px-6 py-2 rounded";
  const step2disabled = category === "" || residenceCountry === "" || city === "" || pin === "" || address1 === "" || (category === "Individual" && relationship === "");

  const checkRequiredCountryBasedInput = () => {
    const requiredFields: Record<string, string | null | undefined> = {
      "United States": routingNumber,
      "Canada": transitCode,
      "Australia": bspCode,
      "United Kingdom": sortCode,
    };
  
    return bankCountry in requiredFields ? !requiredFields[bankCountry] : false;
  };
  
  const requiredCountryBasedInput = checkRequiredCountryBasedInput();

  const step3disabled = bankCountry === "" || acNumber === "" || bankName === null || requiredCountryBasedInput;

  const step4disabled =
    bankAccountNumberCorresponding === "" || bankAccountNameCorresponding === "";

  const countryList = countryOfResidence;

  useEffect(() => {
    window.onbeforeunload = function () {
      return true;
    };

    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  const handleSubmitRecipientDetails = () => {
    !isCorrespondingAccount && isVerified && Mixpanel.track("Corresponding_account_submit");
    setLoading(true);
    const body = {
      firstName: name,
      middleName: "",
      nickName: "",
      lastName: "",
      relationship: relationship,
      bankName: bankName,
      bankAddress: bankAddress,
      sortCode: sortCode,
      swiftCode: swiftCode == "null" ? "" : swiftCode, 
      bsbCode: bspCode,
      achCode: routingNumber,
      ibanCode: iban == "null" ? "" : iban,
      bankAccountNumber: acNumber,
      countryOfResidence: residenceCountry,
      recipientAddress: address1 + address2,
      unitNumber: unitNumber,
      city: city,
      phoneNumber: "",
      email: "",
      pinCode: pin,
      transitCode: transitCode,
      state: "",
      recipientLs: "",
      bankAccountCountry: bankCountry,
      currency: "inr",
      refrence: refrence,
      ifscCode: "",
      bankCode: "",
      type: category.replace(/\s+/g, "_"),
      correspondingBankName: bankAccountNameCorresponding ? bankAccountNameCorresponding : null,
      correspondingBankAccountNumber: bankAccountNumberCorresponding
        ? bankAccountNumberCorresponding
        : null,
    };
    sendRecipients(body)
      .then(() => {
        Mixpanel.track("Submit_step3_recipient_online");
        navigate("/pick-recipient");
      })
      .catch((error) => {
        setErrorMessage(error.response.data.error.type);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    window.onbeforeunload = function () {
      return true;
    };

    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  const handleCloseIcon = () => {
    setIsModalOpen("cancel");
  };

  const handleVerify = () => {
    setLoading(true);
    setBankAddress("");
    setBankName("");
    setAcNumber("");
    setConfirmAcNumber("");
    setBankCountry("");

    if (swiftCode && iban) {
      setValidationError("Please enter either Swift Code or IBAN");
      setLoading(false);
    } else if (swiftCode || iban) {
      const type = swiftCode ? "swift" : "iban";
      const number = swiftCode ? swiftCode : iban;
      setLoading(true);
      validateRecipient(type, number)
        .then((res) => {
          setLoading(false);
          setIsVerified(true);
          setValidationError("");
          Mixpanel.track("Verify_step3_recipient_online");
          setSortCode(res?.data?.branch_code);
          if (type === "swift") {
            setBankAddress(res?.data?.address);
            setBankName(res?.data?.name);
            if (res?.data?.country_name === "AUSTRALIA") {
              setBankCountry("Australia");
            } else if (res?.data?.country_name === "CANADA") {
              setBankCountry("Canada");
            } else if (res?.data?.country_name === "UNITED KINGDOM") {
              setBankCountry("United Kingdom");
            } else if (res?.data?.country_name === "UNITED STATES OF AMERICA") {
              setBankCountry("United States");
            } else setBankCountry(res?.data?.country_name);
          } else if (type === "iban") {
            setBankAddress(res?.data?.address);
            setBankName(res?.data?.bank == "null" ? "" : res?.data?.bank);
            setAcNumber(res?.data?.account);
            setConfirmAcNumber(res?.data?.account);
            setSwiftCode(res?.data?.bic);
            if (res?.data?.country === "AUSTRALIA") {
              setBankCountry("Australia");
            } else if (res?.data?.country === "CANADA") {
              setBankCountry("Canada");
            } else if (res?.data?.country === "UNITED KINGDOM") {
              setBankCountry("United Kingdom");
            } else if (res?.data?.country === "UNITED STATES OF AMERICA") {
              setBankCountry("United States");
            } else setBankCountry(res?.data?.country);
            // setSwiftCode(res?.data?.bic);
          }
        })
        .catch((error) => {
          setLoading(false);
          setValidationError(error.response.data.error.type);
        })
        .finally(() => setLoading(false));
    }
  };

  return (
    <div className="flex flex-col justify-center p-6 items w-[1370px]">
      {/* <div id="header" className="flex justify-between mt-3">
        <div className="flex items-center gap-6">
          <SendButton />
          <div className="flex items-center text-xl font-bold">
          <RemitterIconNew />
          <span className="ml-5">Recipient</span>
          </div>
        </div>
        <div onClick={handleCloseIcon} className="cursor-pointer">
          <CloseIcon fill="black" />
        </div>
      </div> */}
      <div className="flex flex-col items-center w-full ">
        <div id="stepnav" className="flex items-center justify-center mt-20 space-x-10">
          <div id="1" className={step === 0 ? selectedStep : nonSelectedStep}>
            <span className="font-semibold text-[18px]">Step 1</span>
            <span className="">Recipient Details</span>
          </div>
          <RightArrowFilledIcon />
          <div id="2" className={step === 1 ? selectedStep : nonSelectedStep}>
            <span className="font-semibold text-[18px]">Step 2</span>
            <span className="">Recipient Address</span>
          </div>
          <RightArrowFilledIcon />
          <div id="3" className={step === 2 ? selectedStep : nonSelectedStep}>
            <span className="font-semibold text-[18px]">Step 3</span>
            <span className="">Recipient Bank Details</span>
          </div>
          {isCorrespondingAccount && <RightArrowFilledIcon />}
          {isCorrespondingAccount && (
            <div id="4" className={step === 3 ? selectedStep : nonSelectedStep}>
              <span className="font-semibold text-[18px]">Step 4</span>
              <span className="">Corresponding Bank Account</span>
            </div>
          )}
        </div>
        <div>
          {step === 0 && (
            <div className="flex flex-col items-center">
              <div id="stepOne" className="mt-32">
                <StepOne
                  name={name}
                  setName={setName}
                  setIsModalOpen={setIsModalOpen}
                  // relationship={relationship}
                  category={category}
                  setCategory={category}
                />
              </div>
              <div className="flex items-center mt-64">
                <Button
                  disabled={name === "" || category === ""}
                  onClickHandler={() => {
                    setStep(1);
                    Mixpanel.track("Proceed_step1_recipient_online");
                    Mixpanel.track(`Recipient_category_${category}`);
                  }}
                  className={name === "" || category === "" ? disabled : enabled}
                >
                  Proceed
                </Button>
              </div>
            </div>
          )}
          {step === 1 && (
            <div id="stepTwo" className="w-full mt-32">
              <StepTwo
                category={category}
                relationship={relationship}
                // setCategory={setCategory}
                setIsModalOpen={setIsModalOpen}
                residenceCountry={residenceCountry}
                city={city}
                setCity={setCity}
                pin={pin}
                setPin={setPin}
                address1={address1}
                setAddress1={setAddress1}
                address2={address2}
                setAddress2={setAddress2}
                setResidenceCountry={setResidenceCountry}
                countryList={countryList}
              />
              <div className="flex mt-40 ml-6 space-x-20">
                <Button
                  // disabled={step3disabled || acNumber !== confirmAcNumber}
                  onClickHandler={() => setStep(step - 1)}
                  className="px-20 ml-36 py-4 font-bold rounded-md text-white text-[18px] bg-primary-650"
                >
                  Go Back
                </Button>
                <Button
                  disabled={step2disabled}
                  onClickHandler={() => {
                    setStep(2);
                    Mixpanel.track("Proceed_step2_recipient_online");
                  }}
                  className={step2disabled ? disabled : enabled}
                >
                  Proceed
                </Button>
              </div>
            </div>
          )}
          {step === 2 && (
            <div id="stepThree" className="mt-32">
              <StepThree
                setIsModalOpen={setIsModalOpen}
                bankCountry={bankCountry}
                acNumber={acNumber}
                setAcNumber={setAcNumber}
                swiftCode={swiftCode}
                setSwiftCode={setSwiftCode}
                iban={iban}
                setIban={setIban}
                unitNumber={unitNumber}
                setUnitNumber={setUnitNumber}
                confirmAcNumber={confirmAcNumber}
                setConfirmAcNumber={setConfirmAcNumber}
                setBankCountry={setBankCountry}
                countryList={countryList}
                bankName={bankName}
                setBankName={setBankName}
                routingNumber={routingNumber}
                setRoutingNumber={setRoutingNumber}
                transitCode={transitCode}
                setTransitCode={setTransitCode}
                bspCode={bspCode}
                setBspCode={setBspCode}
                sortCode={sortCode}
                setSortCode={setSortCode}
                refrence={refrence}
                setRefrence={setRefrence}
                bankAddress={bankAddress}
                setBankAddress={setBankAddress}
                isCorrespondingAccount={isCorrespondingAccount}
                setIsCorrespondingAccount={setIsCorrespondingAccount}
                isVerified={isVerified}
                setIsVerified={setIsVerified}
                handleVerify={handleVerify}
                isLoading={loading}
                validationError={validationError}
                residenceCountry={residenceCountry}
                loading={loading}
              />
              <div className="flex flex-col mt-40 -ml-32">
                {!isCorrespondingAccount && isVerified ? (
                  <div className="flex space-x-20">
                    <Button
                      onClickHandler={() => {
                        setStep(step - 1);
                        setErrorMessage("");
                      }}
                      className="px-20 ml-36 py-4 font-bold rounded-md text-white text-[18px] bg-primary-650"
                    >
                      Go Back
                    </Button>
                    <Button
                      isLoading={loading}
                      disabled={step3disabled || acNumber !== confirmAcNumber || bankName == ""}
                      onClickHandler={handleSubmitRecipientDetails}
                      className={step3disabled || acNumber !== confirmAcNumber || bankName == "" ? disabled : enabled}
                    >
                      Submit
                    </Button>
                  </div>
                ) : (
                  <div className="flex space-x-20">
                    <Button
                      // disabled={step3disabled || acNumber !== confirmAcNumber}
                      onClickHandler={() => {
                        setStep(step - 1);
                        setErrorMessage("");
                      }}
                      className="px-20 ml-36 py-4 font-bold rounded-md text-white text-[18px] bg-primary-650"
                    >
                      Go Back
                    </Button>
                    <Button
                      disabled={step3disabled || acNumber !== confirmAcNumber}
                      onClickHandler={() => setStep(step + 1)}
                      className={step3disabled || acNumber !== confirmAcNumber ? disabled : enabled}
                    >
                      Next
                    </Button>
                  </div>
                )}
                <div className="mt-3 ml-16 text-red-500">
                  {errorMessage && errorMessage + ". Try after making the changes."}
                </div>
              </div>
            </div>
          )}
          {step === 3 && (
            <div id="stepThree" className="mt-32">
              <StepFour
                bankAccountNameCorresponding={bankAccountNameCorresponding}
                setBankAccountNameCorresponding={setBankAccountNameCorresponding}
                bankAccountNumberCorresponding={bankAccountNumberCorresponding}
                setBankAccountNumberCorresponding={setBankAccountNumberCorresponding}
                setConfirmAccNumber={setConfirmAccNumber}
                confirmAccNumber={confirmAccNumber}
                refrenceCorresponding={refrenceCorresponding}
                setRefrenceCorresponding={setRefrenceCorresponding}
                setStep={setStep}
                handleFinalClick={handleSubmitRecipientDetails}
                setIsCorrespondingAccount={setIsCorrespondingAccount}
                errorMessage={errorMessage}
              />
              <div className="flex flex-col mt-40 ml-6">
                <div className="flex space-x-20">
                  <Button
                    // disabled={step3disabled || acNumber !== confirmAcNumber}
                    onClickHandler={() => {
                      setStep(step - 1);
                      setErrorMessage("");
                      setIsCorrespondingAccount(false);
                    }}
                    className="px-20 ml-36 py-4 font-bold rounded-md text-white text-[18px] bg-primary-650"
                  >
                    Go Back
                  </Button>
                  <Button
                    disabled={step4disabled || bankAccountNumberCorresponding !== confirmAccNumber}
                    isLoading={loading}
                    onClickHandler={handleSubmitRecipientDetails}
                    className={
                      step4disabled || bankAccountNumberCorresponding !== confirmAccNumber
                        ? disabled
                        : enabled
                    }
                  >
                    Submit
                  </Button>
                </div>
                <div className="mt-3 ml-16 text-red-500">
                  {errorMessage && errorMessage + ". Try after making the changes."}
                </div>
              </div>
            </div>
          )}
        </div>
        <Modals
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          setRelationship={setRelationship}
          setCategory={setCategory}
          receivingCountryModalData={receivingCountryData}
          setResidenceCountry={setResidenceCountry}
          setBankCountry={setBankCountry}
        />
      </div>
    </div>
  );
};
